import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoujjaincab() {



    const cardData = {





keyword: "Mumbai to Ujjain Cab",

headingDescription: "Shreesha Tours & Travels provides comfortable and reliable Mumbai to Ujjain Cab Service for pilgrimage tours, family trips, corporate travel, one-way journeys, round trips, and long-distance road travel. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, and premium cab options to ensure a safe and convenient journey from Mumbai to Ujjain. With experienced drivers, well-maintained vehicles, transparent pricing, doorstep pickup, flexible travel plans, and 24/7 customer support, we make your spiritual and personal journeys smooth and hassle-free. Whether you are visiting Ujjain for Mahakaleshwar Jyotirlinga Darshan, religious tourism, family visits, or exploring Madhya Pradesh attractions, Shreesha Tours & Travels provides dependable cab booking services with complete comfort and convenience.",

topPlaces: [
  {
    title: "Mahakaleshwar Jyotirlinga Ujjain",
    description: "Mahakaleshwar Temple is one of the twelve Jyotirlingas of Lord Shiva and one of India's most important pilgrimage destinations. Devotees visit Ujjain throughout the year for spiritual darshan and religious rituals."
  },
  {
    title: "Mahakal Lok Ujjain",
    description: "Mahakal Lok is a grand spiritual corridor developed near Mahakaleshwar Temple, featuring beautiful sculptures, artistic designs, and a peaceful devotional atmosphere."
  },
  {
    title: "Kaal Bhairav Temple Ujjain",
    description: "Kaal Bhairav Temple is a famous ancient temple dedicated to Lord Bhairav and is one of Ujjain's important religious attractions visited by devotees."
  },
  {
    title: "Ram Ghat Ujjain",
    description: "Ram Ghat on the banks of the Shipra River is famous for religious ceremonies, evening aarti, and spiritual gatherings. It is one of the most visited places in Ujjain."
  },
  {
    title: "Harsiddhi Mata Temple Ujjain",
    description: "Harsiddhi Mata Temple is a historic Shakti Peetha and an important religious destination near Mahakaleshwar Temple. It attracts pilgrims throughout the year."
  },
  {
    title: "Sandipani Ashram Ujjain",
    description: "Sandipani Ashram is an ancient spiritual site associated with Lord Krishna's education. It is a popular attraction for devotees and history enthusiasts."
  },
  {
    title: "Omkareshwar Jyotirlinga",
    description: "Omkareshwar is another famous Jyotirlinga destination in Madhya Pradesh located near Ujjain. Many devotees combine Ujjain and Omkareshwar pilgrimage tours."
  },
  {
    title: "Mandu Madhya Pradesh",
    description: "Mandu is a historic destination known for ancient forts, palaces, monuments, and beautiful landscapes. It is a popular heritage attraction near Ujjain."
  },
  {
    title: "Indore",
    description: "Indore is a major city near Ujjain known for Rajwada Palace, Sarafa Bazaar, Lal Bagh Palace, and famous local cuisine. It is often included in Ujjain travel plans."
  },
  {
    title: "Dewas",
    description: "Dewas is a nearby religious and cultural destination famous for Chamunda Mata Temple, hills, and scenic surroundings. It is a convenient stop while exploring the Ujjain region."
  }
],



"services": [
  {
    "name": "Mumbai to Ujjain Cab",
    "description": "Book Mumbai to Ujjain Cab for a safe, comfortable, and reliable pilgrimage journey with professional chauffeurs and well-maintained AC vehicles. Enjoy a smooth road trip from Mumbai to Ujjain with Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cab options suitable for Mahakal Darshan, family trips, religious tours, and long-distance travel."
  },
  {
    "name": "Mumbai to Ujjain Taxi",
    "description": "Choose Mumbai to Ujjain Taxi for convenient and affordable travel with experienced drivers and comfortable vehicles. Get doorstep pickup, clean AC cars, transparent pricing, and reliable taxi service for devotees, families, and travelers visiting Ujjain."
  },
  {
    "name": "Mumbai to Ujjain Cab Service",
    "description": "Book Mumbai to Ujjain Cab Service for dependable outstation transportation with trained chauffeurs and premium vehicles. Our cab services are ideal for Mahakal Darshan, religious journeys, family vacations, and private travel with flexible booking options."
  },
  {
    "name": "Mumbai to Ujjain Taxi Service",
    "description": "Hire Mumbai to Ujjain Taxi Service for smooth interstate travel with professional drivers and well-maintained cars. Enjoy comfortable seating, flexible schedules, affordable fares, and reliable transportation for your spiritual and personal journeys."
  },
  {
    "name": "Mumbai to Ujjain Cab Booking",
    "description": "Complete Mumbai to Ujjain Cab Booking with easy reservations and multiple vehicle choices. Select Sedan, SUV, Ertiga, Innova, or premium cars according to your group size and enjoy a comfortable journey to Ujjain Mahakal Temple."
  },
  {
    "name": "Mumbai to Ujjain Car Rental",
    "description": "Choose Mumbai to Ujjain Car Rental for chauffeur-driven vehicles designed for long-distance and religious travel. Get spacious cars, experienced drivers, flexible rental plans, and comfortable transportation for family and group journeys."
  },
  {
    "name": "Mumbai to Ujjain Mahakal Darshan Cab",
    "description": "Book Mumbai to Ujjain Mahakal Darshan Cab for a convenient pilgrimage experience with dedicated vehicles and professional chauffeurs. Travel comfortably for Mahakaleshwar Jyotirlinga Darshan with family, friends, and religious groups."
  },
  {
    "name": "Mumbai to Ujjain Religious Tour Cab",
    "description": "Choose Mumbai to Ujjain Religious Tour Cab for safe and comfortable spiritual travel. Enjoy reliable vehicles and experienced drivers for Mahakal Darshan, temple visits, and customized religious tour packages from Mumbai."
  },
  {
    "name": "Mumbai to Ujjain One Way Cab",
    "description": "Reserve Mumbai to Ujjain One Way Cab for affordable drop taxi service without return fare charges. Travel comfortably with skilled drivers, clean vehicles, and flexible pickup options for a hassle-free one-way journey."
  },
  {
    "name": "Mumbai to Ujjain Round Trip Taxi",
    "description": "Book Mumbai to Ujjain Round Trip Taxi for complete return travel with flexible timings and comfortable vehicles. Ideal for family pilgrimages, Mahakal Darshan, sightseeing, and extended religious tours."
  },
  {
    "name": "Mumbai Airport to Ujjain Cab",
    "description": "Choose Mumbai Airport to Ujjain Cab for smooth airport transfer and direct outstation travel. Enjoy timely pickup, luggage-friendly vehicles, professional chauffeurs, and comfortable transportation from Mumbai Airport to Ujjain."
  },
  {
    "name": "Mumbai to Ujjain Innova Cab",
    "description": "Book Mumbai to Ujjain Innova Cab for spacious and comfortable travel with premium seating and extra luggage capacity. Perfect for families and groups planning a peaceful Mahakal Darshan journey."
  },
  {
    "name": "Mumbai to Ujjain Ertiga Cab",
    "description": "Reserve Mumbai to Ujjain Ertiga Cab for affordable group transportation with comfortable interiors and smooth performance. Suitable for families and small groups looking for reliable pilgrimage cab services."
  },
  {
    "name": "Best Mumbai Ujjain Taxi Service",
    "description": "Choose the Best Mumbai Ujjain Taxi Service for safe, comfortable, and reliable pilgrimage travel. Enjoy premium vehicles, trained chauffeurs, flexible booking options, and affordable cab packages for Mahakal Darshan, religious tours, family trips, and long-distance journeys from Mumbai to Ujjain."
  }
],
"tableData": [
  ["Mumbai to Ujjain Cab", "Mumbai to Ujjain Taxi"],
  ["Mumbai to Ujjain Cab Service", "Mumbai to Ujjain Taxi Service"],
  ["Mumbai to Ujjain Cab Booking", "Mumbai to Ujjain Car Rental"],
  ["Mumbai to Ujjain Mahakal Darshan Cab", "Mumbai to Ujjain Religious Tour Cab"],
  ["Mumbai to Ujjain One Way Cab", "Mumbai to Ujjain Round Trip Taxi"],
  ["Mumbai Airport to Ujjain Cab", "Mumbai to Ujjain Innova Cab"],
  ["Mumbai to Ujjain Ertiga Cab", "Best Mumbai Ujjain Taxi Service"]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Ujjain Cab Service",
    WhyChoosedescription: "Shreesha Travels provides reliable Mumbai to Ujjain cab services for devotees, families, tourists, and business travellers. Enjoy a smooth journey to the spiritual city of Ujjain with comfortable vehicles, experienced chauffeurs, and flexible travel options."
  },
  {
    WhyChooseheading: "Convenient Spiritual Journey from Mumbai",
    WhyChoosedescription: "Travel from Mumbai to Ujjain for Mahakaleshwar Jyotirlinga darshan and other religious attractions with a private cab service designed for a peaceful and comfortable pilgrimage experience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options for Every Group",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and other vehicles according to your family size and luggage requirements."
  },
  {
    WhyChooseheading: "Ideal for Pilgrimage & Madhya Pradesh Tours",
    WhyChoosedescription: "Our Mumbai to Ujjain taxis are suitable for Mahakaleshwar temple visits, family pilgrimages, spiritual tours, sightseeing trips, and customized Madhya Pradesh travel plans."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Booking",
    WhyChoosedescription: "Book a direct one-way cab to Ujjain or choose a round-trip package with flexible return timing, waiting options, and customized sightseeing arrangements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long Routes",
    WhyChoosedescription: "Our professional chauffeurs have experience with interstate highways and ensure safe driving, timely service, and a comfortable journey from Mumbai to Ujjain."
  },
  {
    WhyChooseheading: "Clean Cars for Long-Distance Travel",
    WhyChoosedescription: "Every vehicle is regularly serviced, cleaned, air-conditioned, and inspected before departure to provide passengers with a reliable and relaxing travel experience."
  },
  {
    WhyChooseheading: "Book Mumbai to Ujjain Cab with Shreesha Travels",
    WhyChoosedescription: "Get transparent pricing, easy booking assistance, comfortable vehicles, and dependable chauffeur-driven cab services for your Mumbai to Ujjain journey."
  }
]

};

const faqData = [
  {
    question: "Can I book a Mumbai to Ujjain cab for Mahakaleshwar darshan?",
    answer: "Yes, we provide comfortable cab services from Mumbai to Ujjain for Mahakaleshwar Jyotirlinga visits, religious tours, and family pilgrimages."
  },
  {
    question: "Is Mumbai to Ujjain one-way cab service available?",
    answer: "Yes, one-way cab bookings are available for travellers who need direct transportation from Mumbai to Ujjain."
  },
  {
    question: "Which vehicles are available for Mumbai to Ujjain travel?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, and Tempo Travellers."
  },
  {
    question: "Can I combine Ujjain with other religious destinations?",
    answer: "Yes, customized routes can include nearby pilgrimage places and sightseeing destinations according to your travel plan."
  },
  {
    question: "Is this cab service comfortable for senior citizens?",
    answer: "Yes, spacious vehicles and experienced drivers make the journey convenient and comfortable for senior citizens."
  },
  {
    question: "Do you provide round-trip Mumbai to Ujjain taxis?",
    answer: "Yes, round-trip cab services are available with flexible return schedules and customized travel options."
  },
  {
    question: "Can I book Mumbai Airport to Ujjain cab service?",
    answer: "Yes, airport pickup and direct cab services can be arranged according to your travel requirements."
  },
  {
    question: "How is the Mumbai to Ujjain cab fare calculated?",
    answer: "The fare depends on vehicle type, travel distance, trip duration, route, waiting time, and selected package."
  },
  {
    question: "Are multi-day religious tours available from Mumbai?",
    answer: "Yes, customized multi-day pilgrimage packages covering Ujjain and nearby destinations can be arranged."
  },
  {
    question: "How can I book Mumbai to Ujjain Cab with Shreesha Travels?",
    answer: "Share your travel date, pickup location, passenger details, preferred vehicle, and trip requirements to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Tiwari",
    feedback: "Our Mumbai to Ujjain pilgrimage journey was very comfortable. The driver was experienced, the car was clean, and the complete trip was managed professionally.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Manisha Joshi",
    feedback: "The Mahakaleshwar temple visit became easy with Shreesha Travels. The smooth ride and reliable service made our family trip memorable.",
    rating: 5
  }
];


    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ujjain Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-ujjain-cab.webp",
  "description":
    "Book Mumbai to Ujjain Cab with Shreesha Tours & Travels for comfortable and reliable pilgrimage taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for Mahakal Darshan, religious tours, family trips, business travel, and long-distance outstation journeys from Mumbai to Ujjain with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-ujjain-cab"
  }
};




    return (
        <div>


<Helmet>
  <title>Mumbai to Ujjain Cab | Mahakal Darshan Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Ujjain Cab with Shreesha Travels for safe and comfortable pilgrimage taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for Mahakal Darshan, Ujjain temple visits, family trips, and outstation travel with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Ujjain Cab, Mumbai to Ujjain Taxi, Mumbai to Ujjain Cab Service, Mumbai to Ujjain Taxi Service, Mumbai to Ujjain Cab Booking, Mumbai to Ujjain Car Rental, Mumbai to Ujjain Mahakal Darshan Cab, Mumbai Ujjain Mahakal Taxi, Mumbai to Ujjain One Way Cab, Mumbai to Ujjain Round Trip Taxi, Ujjain Temple Tour Cab, Mumbai Religious Tour Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/75.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoujjaincab;